import { Fragment, memo } from 'react';

import RoleContentController from 'components/RoleContentController/RoleContentController';
import Typography from 'components/UI/Typography/Typography';
import BonusOpportunity from 'components/pages/RewardSystem/Rules/BonusOpportunity/BonusOpportunity';
import BonusTasks from 'components/pages/RewardSystem/Rules/BonusTasks/BonusTasks';
import HowItWorks from 'components/pages/RewardSystem/Rules/HowItWorks/HowItWorks';

import { ROLES } from 'config/organization';

import styles from './Rules.module.scss';

const Rules = () => (
  <div className={styles.root}>
    <div className={styles.headings}>
      <Typography type="heading-md" weight="medium" uppercase>
        <RoleContentController
          roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}
        >
          {['B2B Reward system rules', 'B2C Reward system rules']}
        </RoleContentController>
      </Typography>
      <Typography color="grey">
        <RoleContentController
          roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}
        >
          {[
            <Fragment key="description-default">
              Welcome to the{' '}
              <Typography element="span" weight="semibold">
                Evoplay Reward System
              </Typography>{' '}
              — a dynamic two-tiered program crafted exclusively for our valued
              B2B partners. <br />
              Earn rewards by achieving marketing goals and meeting key business
              performance indicators.
            </Fragment>,
            <Fragment key="description-media">
              Welcome to the{' '}
              <Typography element="span" weight="semibold">
                Evoplay Reward System
              </Typography>{' '}
              — a loyalty program designed for our valued media and affiliate
              partners. <br />
              Engage with our content, spread the word about our games, and get
              a chance to win prizes!
            </Fragment>,
          ]}
        </RoleContentController>
      </Typography>
    </div>
    <HowItWorks />
    <RoleContentController roles={[ROLES.defaultUser]}>
      {[
        <Fragment key="content-default">
          <BonusOpportunity />
          <BonusTasks />
        </Fragment>,
      ]}
    </RoleContentController>
  </div>
);

export default memo(Rules);
